import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutModule} from './layout/layout.module';
import {MainComponent} from './layout/main/main.component';
import {ClientService} from './services/client.service';
import {PageComponent, PreviewComponent} from '@gallaghercp/core-frontend';
import {MaintenanceComponent} from './layout/maintenance/maintenance.component';

const routes: Routes = [
    {
        path: 'maintenance',
        component: MaintenanceComponent,
    },
    {
        path: 'home',
        redirectTo: '/',
    },
    {
        path: 'preview',
        component: MainComponent,
        children: [
            {
                path: '',
                component: PreviewComponent,
            }
        ]
    },
    {
        path: '',
        component: MainComponent,
        canActivate: [ClientService],
        children: [
            {
                path: '',
                component: PageComponent,
            },
            {
                path: ':identifier',
                component: PageComponent,
            },
        ]
    },
];

@NgModule({
    imports: [
        LayoutModule,
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            scrollOffset: [0, 115] // [x, y]
        })
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {
}
